/**
 * Browser-safe helper functions for tier II submission logic.
 * This file intentionally has no server-side dependencies (no encamp-prisma, encamp-logger, etc.)
 */

/**
 * Determines if the report should be submitted, even if there are no chemicals to report.
 *
 * For CA, reports should still be submitted even if there are no chemicals to report,
 * as long as hazardousMaterialsOnSite is true.
 *
 * @param state - The facility state (e.g., "CA")
 * @param chemicalsCount - Number of reporting facility chemicals
 * @param hazardousMaterialsOnSite - Whether hazardous materials are on site (CA state field)
 * @returns true if the report should be submitted, even if there are no chemicals to report.
 */
export function shouldAllowSubmission(
  state: string,
  chemicalsCount: number,
  hazardousMaterialsOnSite: boolean | undefined
): boolean {
  if (state !== "CA") {
    // For non-CA states, always allow submission if there are chemicals
    return chemicalsCount > 0;
  } else {
    // For CA, allow submission if there are no chemicals and hazardousMaterialsOnSite is false
    if (chemicalsCount === 0 && hazardousMaterialsOnSite === false) {
      return true;
    } else {
      return chemicalsCount > 0;
    }
  }
}
